import { type AnnouncementMediaItem, type AnnouncementMediaSource } from '../constants';

/**
 * Only keys are stored, so each host builds the URL from its own bucket. Null when there is no file or no bucket.
 * Only the first file shows: the design has a single slot.
 * Videos ask imgix for MP4 so `.mov` plays outside Safari; images ask for a format the browser can play.
 */
export const getAnnouncementMediaSource = (
  media: readonly AnnouncementMediaItem[],
  bucket: string | undefined,
): AnnouncementMediaSource | null => {
  const [first] = media;

  if (!first || !bucket) {
    return null;
  }

  const url = new URL(`https://${bucket}.imgix.net`);
  url.pathname = first.key;

  if (first.type === 'video') {
    url.searchParams.set('fm', 'mp4');
  } else {
    url.searchParams.set('auto', 'format');
  }

  return { src: url.toString(), type: first.type };
};
